import { cva, type VariantProps } from 'class-variance-authority';

export const elevationVariants = cva('', {
  variants: {
    elevation: {
      0: '',
      1: 'shadow-[0_2px_2px_0_rgba(0,0,0,0.3),0_-1px_1px_0_rgba(0,0,0,0.03)]',
      2: 'shadow-[0_2px_4px_0_rgba(0,0,0,0.4),0_-1px_4px_0_rgba(0,0,0,0.045)]',
      3: 'shadow-[0_3px_8px_-1px_rgba(0,0,0,0.5),-2px_4px_6px_0_rgba(0,0,0,0.05)]',
      4: 'shadow-[0_3px_10px_-1px_rgba(0,0,0,0.5),-2px_6px_8px_0_rgba(0,0,0,0.05)]',
      5: 'shadow-[0_3px_12px_-1px_rgba(0,0,0,0.55),-2px_6px_8px_0_rgba(0,0,0,0.05)]',
      6: 'shadow-[0_5px_14px_-1px_rgba(0,0,0,0.55),-2px_6px_10px_0_rgba(0,0,0,0.05)]',
      7: 'shadow-[0_7px_16px_-1px_rgba(0,0,0,0.6),-3px_8px_12px_0_rgba(0,0,0,0.055)]',
      8: 'shadow-[2px_9px_18px_-1px_rgba(0,0,0,0.6),1px_-8px_14px_0_rgba(0,0,0,0.06)]',
      9: 'shadow-[4px_11px_18px_-1px_rgba(0,0,0,0.6),-5px_-12px_14px_0_rgba(0,0,0,0.08)]',
      10: 'shadow-[5px_13px_20px_-1px_rgba(0,0,0,0.7),-5px_-15px_17px_0_rgba(0,0,0,0.10)]',
    },
  },
  defaultVariants: {
    elevation: 0,
  },
});

export type ElevationProps = VariantProps<typeof elevationVariants>;